




























import { Component, Vue } from 'vue-property-decorator'
import store from '@/apps/open/store'
import { Route } from 'vue-router'
import { registerEnterpriseDeveloper } from '@/apps/open/services/developer'
import { onRequestError } from '@/apps/open/utils'

@Component
export default class AppAccess extends Vue {
  get userDevelopers () {
    return this.$store.getters['User/userInfo'].developers || []
  }

  get isPrivate () {
    return this.$store.getters['isPrivate']
  }

  get curEnterprise (): any {
    return this.$store.getters['User/curEnterprise']
  }

  beforeRouteEnter (to: any, from: any, next: Function) {
    next((vm: any) => {
      if (vm.curEnterprise && vm.curEnterprise.developer_id) {
        next({ name: 'developer-info' })
      }
    })
  }

  jumpPage (router_name: string) {
    this.$router.push({ name: router_name })
  }

  async handleJumpPage (router_name: string) {
    // to register enterprise developer before jump page
    try {
      if (!this.curEnterprise.developer_id && this.curEnterprise.id) {
        const res = await registerEnterpriseDeveloper(this.curEnterprise.id)
        if (res.data && res.data.result === 'ok') {
          await this.$store.dispatch('User/GET_USER_INFO')
          this.$store.dispatch('User/SET_DEVELOPER_LIST', false)
          const curDeveloper = this.userDevelopers.find((item: any) => item.company_id === this.curEnterprise.id)
          this.$store.commit('User/SET_CUR_ENTERPRISE', curDeveloper)
          this.jumpPage(router_name)
        }
      } else {
        this.jumpPage(router_name)
      }
    } catch (error) {
      this.$message.error(error)
    }
  }
}
